<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.6924 5.79254C16.1025 5.38247 16.1025 4.71762 15.6924 4.30755C15.2824 3.89748 14.6175 3.89748 14.2075 4.30755L10 8.51501L5.79255 4.30755C5.38248 3.89748 4.71763 3.89748 4.30756 4.30755C3.8975 4.71762 3.8975 5.38247 4.30756 5.79254L8.51501 9.99999L4.30755 14.2075C3.89748 14.6175 3.89748 15.2824 4.30755 15.6924C4.71762 16.1025 5.38247 16.1025 5.79254 15.6924L10 11.485L14.2075 15.6924C14.6175 16.1025 15.2824 16.1025 15.6925 15.6924C16.1025 15.2824 16.1025 14.6175 15.6925 14.2075L11.485 9.99999L15.6924 5.79254Z"
      fill="currentColor"
    />
  </svg>
</template>